import { action, observable } from 'mobx';
import { request } from 'utils/api';
import BaseStore from 'common/stores/BaseStore';

export default class FeeStore extends BaseStore {
  @observable transactionFeePercent = null;

  fetchRollerTransactionFeePercent() {
    return request({
      method: 'GET',
      path: '/1/roller/transaction-fee',
    })
      .then((res) => {
        this.transactionFeePercent = res.transactionFeePercent;
        return res.transactionFeePercent;
      })
      .catch((err) => {
        console.error(err);
        this.transactionFeePercent = 0;
        return 0;
      });
  }

  @action
  getRollerTransactionFeePercent() {
    if (this.transactionFeePercent !== null) {
      return Promise.resolve(this.transactionFeePercent);
    }
    return this.fetchRollerTransactionFeePercent();
  }
}
